module.exports = __webpack_public_path__ + "img/Vip_Card_3.14a7bc12.png";